import CheckboxTree, { CheckboxTreeNode, CheckboxTreeStore } from "designSystem/components/checkbox/CheckboxTree";
import { grey } from "designSystem/styles/color";
import { EmptyCardComponent } from "designSystem/components/image/CsiImage";
import { CsiImage, GridRow, OverflowText } from "designSystem/index";
import React from "react";
import Image1 from "./image1.png";

interface CardProps {
	imageSrc?: string;
	name: string;
}

const Card = (props: CardProps) => {
	const { imageSrc, name } = props;

	return (
		<GridRow
			alignItems="center"
			flexWrap="nowrap"
			growChild={1}
			spacing={2}
		>
			<CsiImage
				border="1px solid"
				borderColor={grey[200]}
				borderRadius="3px"
				height={40}
				noImageComponent={<EmptyCardComponent borderless />}
				src={imageSrc}
				width={40}
			/>
			<OverflowText text={name} />
		</GridRow>
	);
};

export default () => {
	const store = new CheckboxTreeStore(undefined, () => console.log("Tree changing"), (node) => console.log("Node changing: ", node.uniqueId));

	const root = store.createNode("rootChild", "test name", true);

	const newChildA = store.createNode("a", "This is the first button.", true, root);
	newChildA.label = Card({ name: "This is the first button", imageSrc: Image1 });

	const newChildB = store.createNode("b", "Another button.", true, root);
	newChildB.label = Card({ name: "Another button", imageSrc: Image1 });

	const newChildC = store.createNode("c", "Button sample text", true, root);
	newChildC.label = Card({ name: "Button sample text", imageSrc: Image1 });

	const secondRoot = store.createNode("rootChild2", "test name2", true);

	const newChildD = store.createNode("d", "Another child", true, secondRoot);
	newChildD.label = Card({ name: "Another Child with a really long name Another Child with a really long name Another Child with a really long name Another Child with a really long name" });

	return (
		<CheckboxTree
			displayCounts
			store={store}
		/>
	);
};